<template>
  <div :class="`vue-filter ${name}-filter`">
    <label v-if="label">{{ label }}</label>

    <div class="filter-wrapper">
      <RadioGroup
        :name="name"
        v-model:value="model"
        :options="options"
      ></RadioGroup>
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/Form/RadioGroup"

export default {
  name: "RadioGroupFilter",
  emits: ["update"],
  directives: {},
  components: {
    RadioGroup,
  },
  props: {
    name: {
      type: String,
      required: true,
      default: () => "filter"
    },
    label: {
      type: String,
      required: false,
      default: () => ""
    },
    value: {
      type: String,
      required: false,
      default() {
        return ""
      }
    },
    options: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    list: {type: Object}
  },
  data() {
    return {
      model: this.value,
      config: {},
      Drupal: this.$drupal,
    }
  },
  watch: {
    model: {
      deep: true,
      handler(to, from) {
        if (!this.$helpers.isEqual(from, to)) {
          this.updateValue()
        }
      },
    },
    value: {
      deep: true,
      handler(to, from) {
        if (!this.$helpers.isEqual(from, to)) {
          this.model = to
        }
      },
    },
  },
  methods: {
    updateValue() {
      // Emit changes to our parent.
      this.$emit("update", this.model)
    },
  }
}
</script>
